import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
  Container,
  TextField,
  Button,
  Box,
  Typography,
  Alert,
} from '@mui/material';

const apiUrl = process.env.REACT_APP_API_URL;

const FarrierProcedureEdit = () => {
  const { procedureId } = useParams();
  const navigate = useNavigate();
  const [procedure, setProcedure] = useState({
    procedure_name: '',
    description: '',
    price: '',
  });
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    axios
      .get(`${apiUrl}/farrier_procedures/${procedureId}`)
      .then((response) => setProcedure(response.data))
      .catch((error) => {
        console.error('Error fetching procedure data:', error);
        setError('Error fetching procedure');
      });
  }, [procedureId]);

  const handleSubmit = (event) => {
    event.preventDefault();
    axios
      .put(`${apiUrl}/farrier_procedures/${procedureId}`, procedure)
      .then(() => {
        setSuccess('Procedure updated successfully');
        navigate('/farrier-procedures');
      })
      .catch((error) => {
        console.error('Error updating procedure:', error);
        setError('Error updating procedure');
      });
  };

  return (
    <Container component="main" maxWidth="lg">
      <Box
        sx={{
          marginTop: 2.5,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography variant="h4" sx={{ mb: 2.5, textAlign: 'center' }}>
          Edit Farrier Procedure
        </Typography>

        {error && <Alert severity="error">{error}</Alert>}
        {success && <Alert severity="success">{success}</Alert>}

        <Box
          component="form"
          sx={{ width: '100%', maxWidth: 600, mt: 2 }}
          onSubmit={handleSubmit}
        >
          <TextField
            label="Procedure Name"
            value={procedure.procedure_name}
            onChange={(e) =>
              setProcedure({ ...procedure, procedure_name: e.target.value })
            }
            fullWidth
            margin="normal"
          />
          <TextField
            label="Description"
            value={procedure.description}
            onChange={(e) =>
              setProcedure({ ...procedure, description: e.target.value })
            }
            fullWidth
            margin="normal"
          />
          <TextField
            label="Price"
            type="number"
            value={procedure.price}
            onChange={(e) =>
              setProcedure({ ...procedure, price: e.target.value })
            }
            fullWidth
            margin="normal"
          />

          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              sx={{ marginRight: 2 }}
            >
              Save
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => navigate('/farrier-procedures')}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default FarrierProcedureEdit;
